// extracted by mini-css-extract-plugin
export default {"editButton":"undoPayrollCalculation_editButton__cMNF1","TableBody":"undoPayrollCalculation_TableBody__OmZiS","StopButton":"undoPayrollCalculation_StopButton__qzX2O"};